
const LEAD_FIELDS = {
  unsubscribed: "{{lead.Unsubscribed}}",
  email: "{{lead.Email Address}}",
  company: "{{company.Company Name}}",
  first_name: "{{lead.First Name}}",
  cemea_subscr: "{{lead.temp-EMEA-CEMEA-Germany-confirmed-subscription}}",
  last_name: "{{lead.Last Name}}"
};

module.exports = {
  LEAD_FIELDS
}



// WEBPACK FOOTER //
// ./src/constants.js